<template>
  <a-card
    class="gd_order_right"
    style="height:100%；"
    :title="`${title}配方`"
    :bordered="false"
    :loading="status === 'loading'"
  >
    <!-- <div v-if="status ==='empty'" class="center">
      <empty-view msg="点击左侧查看配方" />
    </div>-->
    <div class="title_table" style="background-color:#F5F5F5">
      <span>类型</span>
      <span class="text-center">名称</span>
      <span class="text-center">重量</span>
      <span>配比</span>
      <span style="float:right">操作</span>
    </div>
    <div v-for="item in formulasData" :key="item.data.objectId">
      <view-formula-fir :data="item" />
    </div>
  </a-card>
</template>

<script>
import ViewFormulaFir from './viewFormulaFir'
// import Loading from ''
import NP from 'number-precision'
export default {
  props: {
    formulas: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      default: '订单'
    }
  },
  components: {
    ViewFormulaFir
  },
  data () {
    return {
      formulasData: [],
      status: 'empty', // empty：空，loading：加载数据，success：获取数据成功

    }
  },
  watch: {
    formulas: {
      handler (newV) {
        this.formulasData = []
        if (newV && newV.length > 0) {
          this.status = 'loading'
          this.formatData()
        } else {
          this.status = 'empty'
        }
      },
      immediate: true
    }
  },

  methods: {
    // 获取原材料
    async getRawMaterial (data) {
      const { data: res } = await this.$tkParse.get(
        `/classes/rawMaterial/${data.rawMaterial}`
      )
      return res
    },
    // 获取半成品
    async getParts (data) {
      const { data: res } = await this.$tkParse.get(
        `/classes/parts/${data.parts}`
      )
      return res
    },
    async formatData () {
      // this.status = 'loading'
      let allWeight = 0
      for (const item of this.formulas) {
        allWeight = NP.plus(allWeight, item.weight)
        if (item.parts) {
          const res = await this.getParts(item)
          this.formulasData.push({
            data: res,
            weight: item.weight,
            type: 'parts'
          })
        } else {
          const res = await this.getRawMaterial(item)
          this.formulasData.push({
            data: res,
            weight: item.weight,
            type: 'rawMaterial'
          })
        }
      }
      for (const item of this.formulasData) {
        this.$set(
          item,
          'percentage',
          NP.times(Number(NP.divide(item.weight, allWeight).toFixed(4)), 100)
        )
      }
      this.status = 'success'
    }
  }
}
</script>

<style scoped>
/* .center{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
} */

</style>
<style>
.gd_order_right .ant-card-body{
  height: calc(100% - 57px);
}
.view-formila-warp {
  background-color: #fff;
  height: 100%;
  padding: 20px;
}
.title_table {
  height: 50px;
  line-height: 50px;
  font-size: 14px;
  background-color: #fff;
  display: flex;
  justify-content: space-around;
}

.title_table span{
  flex: 1;
}
.title_table {
  border-bottom: 1px solid #e5e7ea;
}
</style>
